export const calculateTotalPages: (count: number | undefined, limit: number) => number = (
  count: number | undefined,
  limit: number,
) => {
  const pages: number = count ? Math.ceil(count / limit) : 0
  return pages
}
